import { render } from "./volume-control.vue?vue&type=template&id=5cf36d5e"
import script from "./volume-control.vue?vue&type=script&lang=js"
export * from "./volume-control.vue?vue&type=script&lang=js"

import "./volume-control.vue?vue&type=style&index=0&id=5cf36d5e&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__